export default {"src":"/_next/static/media/mobileArrowBackBtn.e7d3b79b.svg","height":21,"width":12};